import util from '@utils/util';
import error from '../common/error';
import logreg from '../js/logreg';
import notice from '../common/notice';
import title from '../common/title';
import codeInput from '../common/code';
import button from '../common/button';
import passwordInput from '../common/password';
import api from '../js/api';
export default {
  name: 'loginwrap',
  props: {
    name: {
      type: String,
      default: ''
    },
    itc: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      password: '',
      code: '',
      codeError: '',
      passwordError: '',
      phoneCode: '',
      cover: false,
      codeState: false,
      mPublicKey: ''
    };
  },
  computed: {
    actBtn: function actBtn() {
      return (!!this.code && !this.codeError || !this.codeState) && !!this.password && !this.passwordError;
    }
  },
  components: {
    'error-tip': error,
    'notice-txt': notice,
    'title-txt': title,
    'code-input': codeInput,
    'password-input': passwordInput,
    'button-wrap': button
  },
  methods: {
    changePasswordHandle: function changePasswordHandle(password) {
      this.password = password;
    },
    changePasswordErrorHandle: function changePasswordErrorHandle(txt) {
      this.passwordError = txt;
    },
    changeCodeErrorHandle: function changeCodeErrorHandle(txt) {
      this.codeError = txt;
    },
    changeCodeHandle: function changeCodeHandle(code) {
      this.code = code;
    },
    showForget: function showForget() {
      this.$emit('showForget', this.wayType, this.name, this.itc, this.country);
    },
    logIn: function logIn() {
      var _this = this;
      if (this.password && (this.code && !this.codeError || !this.codeState) && !this.passwordError && !this.cover) {
        this.cover = true;
        var loading = util.loadingFunc();
        logreg.channelSignin(this.name, this.password, this.code, this.mPublicKey, logreg.REGTYPE.phone, 0, function (state, data) {
          _this.cover = false;
          try {
            loading.hide();
          } catch (e) {
            console.log(e);
          }
          if (state === 'success') {
            _this.$emit('success', data);
          } else if (state === 'need_captcha') {
            // this.passwordError = this.$t(this.$loginLangPrefix('userSign.webLoginPasswordErrorTips'));
            if (data.ret && data.ret === '40001') {
              _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeError'));
            } else {
              _this.passwordError = _this.$t(_this.$loginLangPrefix('userSign.webLoginPasswordErrorTips'));
            }
            _this.codeState = true;
          } else if (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf("".concat(data.status)) >= 0 || window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(data.data && "".concat(data.data.status)) >= 0) {
            // this.passwordError = this.$t(this.$loginLangPrefix('userSign.fkError'));
          } else if (data.data && data.data.status === '601') {
            _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeError'));
          } else if (data.errorMessageTMXTip) {
            //
          } else {
            _this.passwordError = _this.$t(_this.$loginLangPrefix('userSign.webLoginPasswordErrorTips'));
          }
          if (_this.codeState) {
            _this.$refs.codeInputRef && _this.$refs.codeInputRef.getVerify();
          }
        });
      }
    },
    keyVal: function keyVal() {
      var _this2 = this;
      api.rsaKey().then(function (data) {
        _this2.mPublicKey = data.pubkey;
        _this2.logIn();
      }).catch(function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  watch: {
    name: function name(val) {
      if (val) {
        var reg = new RegExp(this.itc, 'i');
        this.phoneCode = val.replace(reg, '');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {}
};